























































import { Tx } from "@/models/tx";
import { Wallet } from "@/models/wallet";
import {
  defineComponent,
  PropType,
  computed,
  toRefs
} from "@vue/composition-api";
import { usePrices, useUsdPrice, useUsdTokenPrice } from "@/hooks/use-prices";
import { useERC20 } from "@/hooks/use-erc20";
import { useFilters } from "@/lib/format";

export default defineComponent({
  props: {
    wallet: {
      required: true,
      type: Object as PropType<Wallet>
    },
    divider: Boolean,
    transaction: {
      type: Object as PropType<Tx>,
      default: false
    }
  },
  setup(props) {
    const refs = toRefs(props);
    const inn = computed(() => props.transaction.to === props.wallet.address);
    const { prices, asBaseCurrency, baseCurrency, tokenPrices } = usePrices();
    const { parseERC20Tx } = useERC20();

    const price = computed(() => {
      if (parentToken.value) {
        return useUsdTokenPrice(
          parentToken.value?.address || "",
          refs.transaction.value.value || "",
          parentToken.value?.decimals || 0,
          tokenPrices
        );
      } else {
        return useUsdPrice(
          refs.wallet.value.network.etherscanId || -1,
          refs.transaction.value.value,
          refs.wallet.value.network.decimals,
          prices
        );
      }
    });

    const toToken = computed(() => {
      const address = refs.transaction.value.to;
      const token = ((tokenPrices && tokenPrices.value) || []).find(
        t => t.address === address
      );
      return token;
    });

    const parsedData = computed(() => {
      if (refs.transaction.value || !refs.wallet.value) return null;
      return parseERC20Tx(refs.transaction.value, refs.wallet.value);
    });

    const functionName = computed(() => {
      return parsedData && parsedData?.value?.parsed.functionFragment.name;
    });

    const parentToken = computed(() => {
      const address = refs.transaction.value.parentAddress;
      const token = ((tokenPrices && tokenPrices.value) || []).find(
        t => t.address === address
      );
      return token;
    });

    return {
      ...useFilters(),
      inn,
      price,
      baseCurrency,
      asBaseCurrency,
      parseERC20Tx,
      toToken,
      parentToken,
      parsedData,
      functionName
    };
  }
});
